module.exports = __webpack_public_path__ + "static/img/2_11_25.d4abd59e.png";